import { Card, Col, Row, Typography } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

const Activities = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const activitiesData = [
		{
			key: "bernina",
			image:
				"https://tailormaderail.com/wp-content/uploads/2020/11/Bernina-Head-1024x489.jpg",
		},
		{
			key: "bormio",
			image:
				"https://images.unsplash.com/photo-1551698618-1dfe5d97d256?auto=format&fit=crop&q=80",
		},
		{
			key: "livigno",
			image:
				"https://cdn.holidoit.com/media/articles/18/images/general/Livigno_di_giorno.webp",
		},
		{
			key: "trekking",
			image:
				"https://images.unsplash.com/photo-1551632811-561732d1e306?auto=format&fit=crop&q=80",
		},
	];

	return (
		<Card style={{ margin: "24px" }}>
			<div style={{ background: "#fff" }}>
				<Title level={2} style={{ textAlign: "center", marginBottom: "48px" }}>
					{t("activitiesSection.title")}
				</Title>
				<Row gutter={[24, 24]}>
					{activitiesData.map((activity, index) => (
						<Col xs={24} sm={12} md={6} key={index}>
							<Card
								hoverable
								onClick={() => {
									if (activity.key === "bernina") {
										navigate("/bernina");
									}
								}}
								style={{
									height: "100%",
									display: "flex",
									flexDirection: "column",
								}}
								cover={
									<div
										style={{
											height: 200,
											backgroundImage: `url(${activity.image})`,
											backgroundSize: "cover",
											backgroundPosition: "center",
										}}
									/>
								}
							>
								<Card.Meta
									title={t(`activitiesSection.${activity.key}.title`)}
									description={t(
										`activitiesSection.${activity.key}.description`,
									)}
									style={{ flex: 1 }}
								/>
							</Card>
						</Col>
					))}
				</Row>
			</div>
		</Card>
	);
};

export default Activities;
